import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('variant-operations')
export class VariantOperation {

  @PrimaryGeneratedColumn("increment", { name: 'varient_op_id' })
  VarientOperationId?: number;

  @Column("int", {
    nullable: false,
    name: "varient_id"
  })
  variantId: number;

  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "variant_code"
  })
  variantCode: string;
  @Column("int", {
    nullable: false,
    name: "sequence"
  })
  sequence: number;
  @Column("int", {
    nullable: false,
    name: "operation_id"
  })
  operationId: number;
  @Column("varchar", {
    nullable: false,
    name: "operation_name"
  })
  operationName: string;

  @Column("varchar", {
    nullable: true,
    name: "category",
  })
  operationCategory: string;

  @Column("int", {
    nullable: false,
    name: "operation_group"
  })
  operationGroup: number;
  @Column("int", {
    nullable: false,
    name: "group_dependency"
  })
  groupDependency: number;
  @Column("int", {
    nullable: false,
    name: "operation_dependency"
  })
  operationDependency: number;
  @Column("int", {
    nullable: false,
    default: 0,
    name: "loss_or_gain"
  })
  lossOrGainPercentage: number;

  @Column("int", {
    nullable: false,
    name: "unit_id"
  })
  unitId: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

}
